import React from 'preact/compat'

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Label from './Label';
import colors from '../colors';

import RadioCheckedIcon from '../icons/RadioCheckedIcon';
import RadioUncheckedIcon from '../icons/RadioUncheckedIcon';

export const RadioSelector = ({id, label, options, value, setValue, description, row}) => {
    const handleChange = (e) => {
        setValue(e.target.value);
    }

    return (
    <FormControl>
        <Label id={id} label={label} description={description} />
        <RadioGroup
            aria-labelledby={id + "-label"}
            id={id}
            name={id}
            value={value}
            onChange={handleChange}
            row={row}
            sx={{
                columnGap: '40px',
                paddingLeft: '10px'
            }}
        >
            {options.map(v =>
            <FormControlLabel value={v.value} key={v.value}
                label={v.label}
                sx={{
                    color: colors.secondaryText,
                    '& .MuiFormControlLabel-label': {
                        paddingLeft: '16px',
                        paddingTop: '3px',
                        fontWeight: 400,
                        fontSize: '16px',
                        '&.Mui-disabled': {
                            color: colors.secondaryText
                        }
                    }
                }}
                control={
                    <Radio
                        icon={<RadioUncheckedIcon />}
                        checkedIcon={<RadioCheckedIcon />}
                        sx={{
                            stroke: colors.inputBorder,
                            // padding: !advancedMode ? '6px 3px 6px' : '6px', uncomment for GCP
                            padding: '6px',
                            marginLeft: '-4px',
                            '& .MuiSvgIcon-root': {
                                width: '20px',
                                height: '20px'
                            },
                            '&.Mui-checked': {
                                fill: colors.option,
                                stroke: colors.option
                            },
                            '&.Mui-disabled': {
                                fill: colors.inputBorder,
                                stroke: colors.inputBorder
                            }
                        }}
                        disabled={options.length === 1}
                    />
                }
            />) }
        </RadioGroup>
    </FormControl>);
};

export default RadioSelector;
